// Updated Mock data for Paingoriya and Associates CA Firm Website
// Based on client feedback document

export const firmInfo = {
  name: "Paingoriya & Associates",
  tagline: "Transforming Knowledge into Values",
  taglineHindi: "आपके वित्तीय सफर का साथी।",
  email: "paingoriyaandassociates@gmail.com",
  phone1: "9627181818",
  phone2: "0562-3561851",
  whatsapp: "9627181818",
  headOffice: "D-531, Kamla Nagar, Agra, U.P. India - 282005",
  branchOffice: "12, FF Panchvati Plaza, Tajnagari, Phase 2, Agra – 282001, Uttar Pradesh, India",
  foundedYear: 2013,
  experience: "13+",
  description: "We are a professionally managed CA firm established in 2013, offering a wide spectrum of services in the field of accounting, audit, taxation, GST, company law compliance, and financial consultancy. With a client-centric approach and a commitment to integrity, we ensure your business and financial decisions are compliant, efficient, and growth-oriented.",
  mission: "To deliver accurate, timely, and ethical financial solutions.",
  vision: "To be recognized as a dependable and dynamic CA firm serving pan-India with excellence."
};

export const services = [
  // Audit and Assurance
  {
    id: 1,
    title: "Statutory Audit",
    description: "Comprehensive statutory audit services ensuring compliance with legal requirements and financial accuracy.",
    icon: "FileSearch",
    category: "Audit and Assurance"
  },
  {
    id: 2,
    title: "Tax Audit",
    description: "Expert tax audit services under Section 44AB of the Income Tax Act for businesses and professionals.",
    icon: "Calculator",
    category: "Audit and Assurance"
  },
  {
    id: 3,
    title: "Internal Audit",
    description: "Systematic internal audit to improve effectiveness of risk management and control processes.",
    icon: "ClipboardCheck",
    category: "Audit and Assurance"
  },
  {
    id: 4,
    title: "Stock and System Audit",
    description: "Detailed stock verification and system audit for banks and financial institutions.",
    icon: "Package",
    category: "Audit and Assurance"
  },
  // Income Tax Services
  {
    id: 5,
    title: "ITR Filing",
    description: "Income Tax Return filing for Individuals, HUFs, Firms & Companies with maximum tax benefits.",
    icon: "FileText",
    category: "Income Tax Services"
  },
  {
    id: 6,
    title: "Tax Planning and Advisory",
    description: "Strategic tax planning to minimize liability and maximize savings legally.",
    icon: "TrendingUp",
    category: "Income Tax Services"
  },
  {
    id: 7,
    title: "Assessment & Scrutiny Handling",
    description: "Expert handling of income tax assessments, scrutiny cases, and departmental proceedings.",
    icon: "Scale",
    category: "Income Tax Services"
  },
  // GST Services
  {
    id: 8,
    title: "GST Registration",
    description: "Complete GST registration services for all types of businesses and entities.",
    icon: "Receipt",
    category: "GST Services"
  },
  {
    id: 9,
    title: "GST Return Filing",
    description: "Timely filing of GSTR-1, GSTR-3B, GSTR-9 and all other GST returns.",
    icon: "FileSpreadsheet",
    category: "GST Services"
  },
  {
    id: 10,
    title: "GST Audit & Annual Return",
    description: "GST audit and annual return preparation with reconciliation and compliance check.",
    icon: "ClipboardList",
    category: "GST Services"
  },
  {
    id: 11,
    title: "LUT Filing & Refund Assistance",
    description: "Letter of Undertaking filing and GST refund claim assistance for exporters.",
    icon: "RefreshCcw",
    category: "GST Services"
  },
  // Company Law Services
  {
    id: 12,
    title: "Company Incorporation",
    description: "Incorporation of Private Limited, LLP, OPC and other business entities.",
    icon: "Building2",
    category: "Company Law Services"
  },
  {
    id: 13,
    title: "Annual Filing with MCA",
    description: "Annual ROC compliance including AOC-4, MGT-7, and other statutory filings.",
    icon: "FolderOpen",
    category: "Company Law Services"
  },
  {
    id: 14,
    title: "Director KYC & DIN",
    description: "Director KYC, Share Transfers, DIN Applications and related services.",
    icon: "UserCheck",
    category: "Company Law Services"
  },
  // TDS, PF & ESI
  {
    id: 15,
    title: "TDS Returns",
    description: "Quarterly TDS return filing with accurate computation and timely compliance.",
    icon: "FileMinus",
    category: "TDS, PF & ESI Compliance"
  },
  {
    id: 16,
    title: "PF & ESI Registration and Filing",
    description: "Complete PF and ESI registration, monthly filing and compliance management.",
    icon: "Shield",
    category: "TDS, PF & ESI Compliance"
  },
  {
    id: 17,
    title: "Payroll Structuring",
    description: "Salary structuring for tax efficiency and statutory compliance.",
    icon: "Wallet",
    category: "TDS, PF & ESI Compliance"
  },
  // Bookkeeping & Accounting
  {
    id: 18,
    title: "Monthly Accounting",
    description: "Regular monthly accounting and bookkeeping services for businesses.",
    icon: "BookOpen",
    category: "Bookkeeping & Accounting"
  },
  {
    id: 19,
    title: "Finalization of Accounts",
    description: "Year-end finalization of accounts with complete financial statements.",
    icon: "CheckCircle",
    category: "Bookkeeping & Accounting"
  },
  {
    id: 20,
    title: "MIS Reports",
    description: "Management Information System reports for informed business decisions.",
    icon: "BarChart3",
    category: "Bookkeeping & Accounting"
  },
  // Financial Advisory
  {
    id: 21,
    title: "Tax-saving Investments",
    description: "Advisory on tax-saving investment options under various sections.",
    icon: "PiggyBank",
    category: "Financial & Investment Advisory"
  },
  {
    id: 22,
    title: "Business Financial Planning",
    description: "Comprehensive financial planning for business growth and sustainability.",
    icon: "Target",
    category: "Financial & Investment Advisory"
  },
  {
    id: 23,
    title: "Budgeting & Forecasting",
    description: "Budget preparation and financial forecasting for strategic planning.",
    icon: "LineChart",
    category: "Financial & Investment Advisory"
  },
  // Representation Services
  {
    id: 24,
    title: "Reply to Notices",
    description: "Expert drafting and reply to income tax and GST notices.",
    icon: "MessageSquare",
    category: "Representation Services"
  },
  {
    id: 25,
    title: "Representation before Authorities",
    description: "Representation before Income Tax and GST authorities for assessments and appeals.",
    icon: "Users",
    category: "Representation Services"
  },
  {
    id: 26,
    title: "Appeal Filing & Drafting",
    description: "Filing of appeals and drafting submissions before appellate authorities.",
    icon: "Gavel",
    category: "Representation Services"
  },
  // NGO and Trust
  {
    id: 27,
    title: "12A, 80G Registration",
    description: "Registration under Section 12A and 80G for NGOs and charitable trusts.",
    icon: "Heart",
    category: "NGO and Trust Compliance"
  },
  {
    id: 28,
    title: "FCRA Advisory",
    description: "FCRA registration and compliance advisory for foreign contributions.",
    icon: "Globe",
    category: "NGO and Trust Compliance"
  }
];

export const serviceCategories = [
  "Audit and Assurance",
  "Income Tax Services", 
  "GST Services",
  "Company Law Services",
  "TDS, PF & ESI Compliance",
  "Bookkeeping & Accounting",
  "Financial & Investment Advisory",
  "Representation Services",
  "NGO and Trust Compliance"
];

export const stats = [
  { label: "Happy Clients", value: "500+" },
  { label: "Years Experience", value: "13+" },
  { label: "Services Offered", value: "30+" },
  { label: "Team Members", value: "15+" }
];

export const updates = [
  {
    id: 1,
    title: "Union Budget 2026: Key tax & GST changes",
    date: "2026-01-23",
    description: "Under the new law, finance leaders are expected to keep an eye on the precise mapping of provisions, deadlines, and compliance procedures.",
    category: "Tax"
  },
  {
    id: 2,
    title: "ITR Filing Deadline Extended",
    date: "2025-07-31",
    description: "The deadline for ITR filing for AY 2025-26 has been extended. Contact us for timely filing.",
    category: "Tax"
  },
  {
    id: 3,
    title: "New GST Return System",
    date: "2025-07-15",
    description: "New simplified GST return filing system launched. We help you migrate seamlessly.",
    category: "GST"
  },
  {
    id: 4,
    title: "MSME Registration Benefits 2025",
    date: "2025-06-20",
    description: "Enhanced benefits announced for MSME registered businesses. Register now to avail.",
    category: "Business"
  },
  {
    id: 5,
    title: "Digital Signature New Guidelines",
    date: "2025-06-01",
    description: "Updated guidelines for Digital Signature Certificates. Ensure compliance with new norms.",
    category: "Compliance"
  },
  {
    id: 6,
    title: "Digital Signature New Guidelines",
    date: "2025-06-01",
    description: "Updated guidelines for Digital Signature Certificates. Ensure compliance with new norms.",
    category: "Compliance"
  }
];

export const testimonials = [
  {
    id: 1,
    name: " Vishnu Gupta",
    company: "Devta HP Filling Station",
    text: "Excellent service! Paingoriya & Associates helped us with our company registration and GST compliance. Highly professional team.",
    rating: 5
  },
  {
    id: 2,
    name: "Suresh Sharma",
    company: " Diya Industries",
    text: "Very knowledgeable and helpful. They made FSSAI registration process smooth and hassle-free.",
    rating: 5
  },
  {
    id: 3,
    name: "Sonendra Chauhan",
    company: "Kunal Glass Export",
    text: "Great experience with IEC registration and GST refund assistance. The team is responsive and delivers on time.",
    rating: 5
  }
];

export const images = {
  hero: "https://customer-assets.emergentagent.com/job_accounting-pros-7/artifacts/bksoga8n_WhatsApp%20Image%202026-01-15%20at%207.40.34%20PM.jpeg",
  about: "https://images.unsplash.com/photo-1733477590442-4c0ec14e6202?w=800&q=80",
  services: "https://images.unsplash.com/photo-1718220216044-006f43e3a9b1?w=800&q=80",
  trust: "https://images.unsplash.com/photo-1758518730384-be3d205838e8?w=800&q=80"
};

export const teamMembers = [
  {
    id: 1,
    name: "CA Peeyush Paingoriya",
    designation: "Founder",
    qualification: "B.com, FCA, DISA, CCA, Certified Arbitrator by ICAI",
    description: "CA Peeyush Pengoria is a seasoned Chartered Accountant with over 13 years of rich professional experience, practicing since 2013. He is the Founder of Paingoriya & Associates, a proprietorship firm committed to delivering ethical, practical, and result-oriented professional services.Qualified as a Chartered Accountant at the young age of 22, CA Peeyush Pengoria hails from a very rural town – Bah, District Agra (Uttar Pradesh), located approximately 70 km from Agra. His journey from a rural background to building a respected professional practice reflects strong dedication, discipline, and a deep understanding of grassroots-level business challenges.To keep pace with the evolving professional landscape, he continuously upgrades his expertise. He is a DISA-qualified professional (2025), a Certified Concurrent Auditor by ICAI, and a Certified Arbitrator by ICAI, enabling him to serve clients with a multidisciplinary and technology-driven approach.With hands-on exposure across diverse domains, he possesses extensive experience in Statutory Audits, Tax Audits, GST Audits & Compliance, Project Financing, Advisory Services, and other allied professional areas. His practical insights and solution-focused mindset help clients achieve compliance while supporting sustainable business growth.Under his leadership, Paingoriya & Associates stands for professional integrity, personalized attention, and reliable advisory, catering to individuals, SMEs, and growing enterprises across sectors.CA Peeyush Pengoria believes in building long-term client relationships through trust, transparency, and value-driven services, with a strong commitment to professional excellence and continuous learning.",
    image: "https://raw.githubusercontent.com/riya1234567/peeyush-assets/main/peeyush.jpg"
  },
  {
    id: 2,
    name: "Adv Pooja Gupta",
    designation: "Associate Member",
    qualification: "B.Com, M.Com, LL.B",
    description: "Adv. Pooja Gupta is an accomplished legal professional associated with Paingoriya & Associates, providing comprehensive legal and compliance support to clients.She holds strong academic credentials with qualifications of B.Com, M.Com, and LL.B., and has pursued her legal education from the renowned Government institution – Agra College of Law, Agra, known for its academic rigor and legacy in legal studies.Adv. Pooja Gupta is AIBE (All India Bar Examination) qualified, enabling her to actively practice law and represent clients with competence and professional responsibility. Her background in commerce along with legal education allows her to effectively handle matters involving commercial laws, taxation-related legal issues, contractual matters, regulatory compliance, and advisory support.With a detail-oriented and research-driven approach, she assists clients in navigating complex legal frameworks while ensuring clarity, compliance, and risk mitigation. Her association strengthens the firm’s multidisciplinary capability by seamlessly integrating legal expertise with financial and tax advisory services.Adv. Pooja Gupta believes in ethical practice, client confidentiality, and providing practical legal solutions aligned with business objectives.",
    image: "https://ui-avatars.com/api/?name=Pooja+Gupta&size=200&background=059669&color=fff&bold=true"
  }
];
